
  import moment from "moment"
import { Vue, Prop } from "vue-property-decorator";

export default class Tirscript3Hours extends Vue {
  @Prop({ default: () => new Date(), type: Date }) date: Date;
  @Prop({ type: Function }) allowedToShowView: Function;

  innerHours:any[] = [];
  innerMonth:number;
  innerYear:number;
  innerDay:number;
  innerHour:number;

  mounted() {
  this.innerMonth = this.date.getMonth();
  this.innerYear = this.date.getFullYear();
  this.innerDay = this.date.getDate();
  this.innerHour = this.date.getHours();
    this.setDay(this.date);
    for (let index = 0; index < 24; index++) {
      this.innerHours.push({
        name:
          index.toLocaleString("en-US", {
            minimumIntegerDigits: 2,
            useGrouping: false
          }) + ":00",
        number: index,
        type: index == this.innerHour ? "current" : ""
      });
    }
  }

  // getMonths() {
  //   return this.months.map(function(item, index) {
  //     return { number: index, name: item };
  //   });
  // }

  setDay(date:Date) {
    this.innerDay = date.getDate();
  }
  next() {
    this.setDay(new Date(this.innerYear, this.innerMonth, this.innerDay + 1));
  }
  backward() {
    this.setDay(new Date(this.innerYear, this.innerMonth, this.innerDay - 1));
  }
  filterMoment(date: Date, filter: string) {
    return moment(date).format(filter)
  }
  changeHour(hour:any) {
    if (hour.type == "") {
      this.clearHours();
      hour.type = "current";
    }
    this.innerHour = hour.number;
    this.$emit(
      "changeHour",
      new Date(this.innerYear, this.innerMonth, this.innerDay, hour.number, 0)
    );
  }
  changeDays() {
    this.$emit("onNavigation");
  }
  clearHours() {
    for (let index = 0; index < this.innerHours.length; index++) {
      if (this.innerHours[index].type == "current") {
        this.innerHours[index].type = "";
      }
    }
  }
  openDays() {
    this.$emit("changeCurrentView", "days");
  }
}
